var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.recipes),function(recipe){return _c('li',{key:recipe.slug},[_c('router-link',{attrs:{"to":'/recipe/' + recipe.slug}},[_vm._v(_vm._s(recipe.name))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }